module.exports = __webpack_public_path__ + "img/review-titan.491fef6f.webp";